 

export default class Notfound extends React.Component{
  constructor(props){
    super(props); 

  }
 
  render(){
 return (<>Url Not Found !</>)

  }
}